export const parseCepikMergeResultKey = (key: string) =>
  key?.endsWith('CheckoutForm')
    ? key.substring(0, key.length - 12).replace(/\./g, '_')
    : key.replace(/\./g, '_');
